import { render, staticRenderFns } from "./ReservesView.vue?vue&type=template&id=f14a8b8e&scoped=true&"
import script from "./ReservesView.vue?vue&type=script&lang=js&"
export * from "./ReservesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14a8b8e",
  null
  
)

export default component.exports